import { ref } from 'vue'
import { defineStore } from 'pinia'
import { searchPatient } from '../../services/api/fhirAPI/patient/patient.js'
import { useSelectedPlan } from '../../stores/plans/selectedPlan.js'
import { retrieveCoverage } from '../../composables/coverage.comp.js'

export const usePatientData = defineStore(
	'patientData',
	() => {
		// ====---------------====
		// State
		// ====---------------====
		const planStore = useSelectedPlan()
		const patientData = ref<object>({})
		const loaded = ref(false)

		// ====---------------====
		// Getters
		// ====---------------====

		// ====---------------====
		// Actions
		// ====---------------====
		function updatePatientData(memberId: string, payload: object) {
			patientData.value[memberId] = payload
			loaded.value = true
		}

		function $reset() {
			patientData.value = {}
			loaded.value = false
		}

		function resetPatientData() {
			$reset()
		}

		let loadPatientRequest: Promise<string> | null = null
		async function loadPatientData() {
			if (loadPatientRequest) {
				return loadPatientRequest
			}

			loadPatientRequest = new Promise(async (resolve, reject) => {
				try {
					if (planStore.isPolicyHolder) {
						await retrieveCoverage()
						await searchPatient(planStore.contractId)
							.then((res) => {
								if (res.entry.length === 1 && res.entry[0].resource?.issue?.code == 'exception')
									throw new Error()
								res.entry.forEach((member: { [key: string]: any }) => {
									updatePatientData(member.resource.id, member.resource)
								})
							})
							.catch((err) => {
								console.error(err)
							})
					} else {
						// if not policy holder only grab by memberId
						await searchPatient(planStore.memberId)
							.then((res) => {
								if (res.entry.length === 1 && res.entry[0].resource?.issue?.code == 'exception')
									throw new Error()
								res.entry.forEach((member: { [key: string]: any }) => {
									updatePatientData(member.resource.id, member.resource)
								})
							})
							.catch((err) => {
								console.error(err)
							})
					}
					resolve('')
				} catch (err) {
					reject(err)
				} finally {
					loadPatientRequest = null
				}
			})
			return loadPatientRequest
		}

		// ====---------------====
		// Return
		// ====---------------====
		return {
			patientData,
			loaded,
			loadPatientData,
			updatePatientData,
			resetPatientData,
			$reset
		}
	},
	{
		persist: {
			storage: sessionStorage
		}
	}
)
